import React from 'react';
import Checkbox from './Checkbox';

class CheckboxCounter extends React.Component {
  render = () => {
    const { name, value } = this.props;
    return (
      <div className="checkbox-counter">
        {value > 0 ? (
          this.renderValue()
        ) : (
          <Checkbox name={name} onChange={this.handleCheckboxChange} />
        )}
      </div>
    );
  };

  renderValue() {
    return (
      <div className="checkbox-counter__clicker">
        <span
          className="checkbox-counter__increment"
          onClick={this.handleIncrement}
        >
          +
        </span>
        <p className="p">{this.props.value}</p>
        <span
          className="checkbox-counter__decrement"
          onClick={this.handleDecrement}
        >
          –
        </span>
      </div>
    );
  }

  handleCheckboxChange = e => {
    this.props.onChange({ name: e.target.name, value: 1 });
  };

  handleIncrement = () => {
    const { name, value } = this.props;
    this.props.onChange({ name, value: value + 1 });
  };

  handleDecrement = () => {
    const { name, value } = this.props;
    this.props.onChange({ name, value: value - 1 });
  };
}

export default CheckboxCounter;



// WEBPACK FOOTER //
// ./src/components/form/CheckboxCounter.js